import { render } from "./SettingsRequiredFields.vue?vue&type=template&id=7ca31a22"
import script from "./SettingsRequiredFields.vue?vue&type=script&lang=js"
export * from "./SettingsRequiredFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__